<!-- ===== DESKTOP TABLE ===== -->
<div class="data-table">
  <div class="data-table__head" *ngIf="data.headers">
    <div class="data-table__cell data-table__cell--head" *ngFor="let col of data.headers; let i = index"
      [ngClass]="{
        'data-table__cell--status': data.keys[i] === 'status',
        'data-table__cell--date': data.keys[i] === 'created_at',
        'data-table__cell--voie': data.keys[i] === 'voie'
      }">
      {{ col }}
    </div>
  </div>

  <div class="data-table__body">
    <div class="data-table__row" *ngFor="let row of data.data" (click)="selectRow(row)" [class.data-table__row--clickable]="clickable">
      <div class="data-table__cell" *ngFor="let col of data.headers; let i = index"
        [ngClass]="{
          'data-table__cell--status': data.keys[i] === 'status',
          'data-table__cell--date': data.keys[i] === 'created_at',
          'data-table__cell--voie': data.keys[i] === 'voie'
        }">

        <!-- Status badge -->
        <span
          *ngIf="data.keys[i] === 'status'"
          class="pill"
          [class.pill--light]="row.si_statut && row.si_statut.code !== 50 && row.si_statut.code !== 11"
          [class.pill--dark]="row.si_statut && (row.si_statut.code === 50 || row.si_statut.code === 11)"
          [style.--pill-bg]="row.status_color || 'var(--light-gray-2)'"
        >{{ row[data.keys[i]] }}</span>

        <!-- Date -->
        <span *ngIf="data.keys[i] === 'created_at' && row[data.keys[i]]" class="date-text">
          {{ row[data.keys[i]] | date:'dd/MM/yy' }}
        </span>
        <span *ngIf="data.keys[i] === 'created_at' && !row[data.keys[i]]" class="date-text date-text--empty">—</span>

        <!-- Default cell -->
        <span *ngIf="data.keys[i] !== 'status' && data.keys[i] !== 'created_at'" class="cell-text">
          {{ row[data.keys[i]] }}
        </span>
      </div>
    </div>
  </div>
</div>

<!-- ===== MOBILE TABLE ===== -->
<div class="mobile-table">
  <div class="mobile-table__card" *ngFor="let row of data.data" (click)="selectRow(row)" [class.mobile-table__card--clickable]="clickable">
    <div class="mobile-table__row" *ngFor="let col of data.headers; let i = index">
      <span class="mobile-table__label">{{ col }}</span>

      <span *ngIf="data.keys[i] === 'status'" class="pill pill--sm"
        [class.pill--light]="row.si_statut && row.si_statut.code !== 50 && row.si_statut.code !== 11"
        [class.pill--dark]="row.si_statut && (row.si_statut.code === 50 || row.si_statut.code === 11)"
        [style.--pill-bg]="row.status_color || 'var(--light-gray-2)'"
      >{{ row[data.keys[i]] }}</span>

      <span *ngIf="data.keys[i] === 'created_at' && row[data.keys[i]]" class="date-text">
        {{ row[data.keys[i]] | date:'dd/MM/yy' }}
      </span>
      <span *ngIf="data.keys[i] === 'created_at' && !row[data.keys[i]]" class="date-text date-text--empty">—</span>

      <span *ngIf="data.keys[i] !== 'status' && data.keys[i] !== 'created_at'" class="cell-text">
        {{ row[data.keys[i]] }}
      </span>
    </div>
  </div>
</div>
